import React, { memo, useCallback } from 'react'

import { Button, Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, node, oneOf, string } from 'prop-types'

import { useSubscriptionHref } from 'Pods/ThreeDStudio/Hooks/useSubscriptionHref'

// react-tooltip centers the card on the trigger; shift it down so its bottom
// edge lines up with the trigger's bottom (the bottom of .model-card__content).
// react-tooltip@3 calls overridePosition with two different argument orders
// (showTooltip vs updatePosition), so resolve the trigger/tooltip nodes by
// scanning the args rather than relying on a fixed position.
const alignBottomPosition = (position, ...rest) => {
  const nodes = rest.filter((arg) => arg && typeof arg.getBoundingClientRect === 'function')
  const tooltip = nodes.find((el) => el.classList && el.classList.contains('cgt-tooltip'))
  const trigger = nodes.find((el) => el !== tooltip)
  if (!tooltip || !trigger) {
    return position
  }
  const delta = ((trigger.getBoundingClientRect().height - tooltip.getBoundingClientRect().height) / 2) + 8
  return { left: position.left, top: position.top + delta }
}

function SubscribersOnlyHover({ id, children, placement = 'top', alignBottom = false, containerClassName = '' }) {
  const subscriptionHref = useSubscriptionHref()

  const handleGetSubscription = useCallback(() => {
    window.location.assign(subscriptionHref)
  }, [subscriptionHref])

  const card = (
    <div className="subscribers-only-hover__card">
      <span className="subscribers-only-hover__title cgt-heading-50">For Subscribers Only</span>
      <Button size="small" onClick={handleGetSubscription}>Get Subscription</Button>
    </div>
  )

  return (
    <Tooltip
      id={id}
      content={card}
      place={placement}
      clickable
      overridePosition={alignBottom ? alignBottomPosition : undefined}
      containerClass={`subscribers-only-hover ${containerClassName}`.trim()}
      className="subscribers-only-hover__trigger"
      tooltipClassName="subscribers-only-hover__tooltip"
    >
      {children}
    </Tooltip>
  )
}

SubscribersOnlyHover.propTypes = {
  id: string.isRequired,
  children: node.isRequired,
  placement: oneOf(['top', 'right']),
  alignBottom: bool,
  containerClassName: string,
}

export default memo(SubscribersOnlyHover)
